// extracted by mini-css-extract-plugin
export default {"container":"pFYuu","tabsContainer":"IkpLO","menuHeader":"ujg1P"};